
<div class="hero-profile">
    <h3>Featured Hero Profile</h3>
    <h4>{{ name }}</h4>
    <p>{{ bio }}</p>
    <strong>Hire this hero today!</strong>
  </div>